import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Logo } from '@/components/motion/Primitives';
import { getErrorMessage } from '@/lib/format';

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const redirect = params.get('redirect') || '/account';
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const user = await login(email, password);
            toast.success(`Welcome back, ${user.name}!`);
            navigate(user.role === 'admin' ? '/admin' : redirect);
        } catch (err) {
            toast.error(getErrorMessage(err, 'Login failed.'));
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-[70vh] grid place-items-center px-4 py-16 section-wash">
            <div className="w-full max-w-md rounded-3xl border border-border bg-white p-8 shadow-[0_20px_60px_rgba(2,6,23,0.08)]">
                <div className="flex justify-center"><Logo className="h-9" /></div>
                <h1 className="font-display text-2xl font-bold text-center mt-4">Welcome back</h1>
                <p className="text-center text-sm text-[var(--ink-muted)] mt-1">Log in to your xtra account</p>
                <form onSubmit={submit} className="mt-6 space-y-4">
                    <div><Label htmlFor="email">Email</Label><Input id="email" data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11" placeholder="you@email.com" /></div>
                    <div><Label htmlFor="password">Password</Label><Input id="password" data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11" placeholder="••••••••" /></div>
                    <button data-testid="login-submit-button" disabled={loading} className="btn-primary w-full h-12 disabled:opacity-80">{loading ? <Loader2 className="h-5 w-5 animate-spin" /> : 'Log in'}</button>
                </form>
                <p className="mt-5 text-center text-sm text-[var(--ink-muted)]">New to xtra? <Link to="/signup" className="text-[var(--brand-blue)] font-semibold hover:underline">Create an account</Link></p>
            </div>
        </div>
    );
}
